import React from "react";
import { ReactComponent as HeartActive } from "../../assets/svg/heart-active.svg";
import { ReactComponent as Comment } from "../../assets/svg/comment.svg";
import _ from "lodash";
import appRoutes from "../../routes/app.routes";
import NotFoundPage from "../../components/common/NotFoundPage";
import { openUrlInNewTab, stripHTMLTags } from "../../utils/helper";
import { ReactComponent as Heart } from "../../assets/svg/heart.svg";

interface candidateFeedProps {
  feed: [];
  publicPage?: boolean;
  type: number;
}

interface postTypes {
  id: string;
  content: string;
  post_comments: [];
  post_comments_count: number;
  post_likes_count: number;
  post_media: undefined | string;
  slug: string;
  cover_image: string;
}

const Feed: React.FC<candidateFeedProps> = ({ feed, publicPage, type }) => {
  const getFeedItem = (post: postTypes) => {
      const plainTextContent = stripHTMLTags(post.content || "");
  const displayText =
    plainTextContent.length > 200
      ? plainTextContent.substring(0, 200) + "..."
      : plainTextContent;
    return (
      <>
    {!_.isEmpty(displayText) && (
        <div className="feed-content-info wysiwyg-data">{displayText}</div>
      )}
        {(!_.isEmpty(post.post_media) || !_.isEmpty(post.cover_image)) && (
          <div className="img-wrapper">
            <img
              src={type === 0 ? post.post_media : post.cover_image}
              alt="Feed-thumbnail"
            />
          </div>
        )}
        <div className="feed-footer">
          <ul>
            <li>
              
              {_.get(post, "post_likes_count", 0) > 0 ? (
                <HeartActive />
              ) : (
                <Heart />
              )}{" "}
              <span>{post.post_likes_count}</span>
            </li>
            <li>
              <Comment /> {post.post_comments_count}
            </li>
          </ul>
        </div>
      </>
    );
  };
  return (
    <div className="feed-content feed-public-wrapper">
      <div className="edit-wrapper">
        <h4>{type === 0 ? "Feed" : "Articles"}</h4>
      </div>
      {!_.isEmpty(feed) ? (
        <div className="feed-content-wrapper">
          {!_.isEmpty(feed) &&
            feed.map((post: postTypes) => (
              <div
                className="feeds-card"
                onClick={() => {
                  openUrlInNewTab(
                    appRoutes.FeedDetails.generateFullPath(post?.slug)
                  );
                }}
              >
                {getFeedItem(post)}
              </div>
            ))}
        </div>
      ) : (
        <NotFoundPage content="No feeds found" />
      )}
    </div>
  );
};

export default Feed;
